import { $generateHtmlFromNodes } from "@lexical/html";
import type { SerialisedEditorDesign } from "../types/serialised-editor-design";
import { createConfiguredEditor } from "./headless-editor";

export function serialisedEditorDesignToPlainText(
  design: SerialisedEditorDesign | null | undefined,
): string {
  if (!design) return "";
  if ("markdown" in design) return normalisePlainText(design.markdown);

  const editor = createConfiguredEditor({ format: "email" });
  editor.setEditorState(editor.parseEditorState(JSON.stringify(design)));

  let html = "";
  editor.update(
    () => {
      html = $generateHtmlFromNodes(editor, null);
    },
    { discrete: true },
  );

  const element = document.createElement("div");
  element.innerHTML = html;
  return normalisePlainText(element.innerText ?? element.textContent ?? "");
}

function normalisePlainText(text: string): string {
  return text.replace(/\s+/g, " ").trim();
}
